<template>
  <div class="login">
    <div class="login">
      <video :src="demoVideo" autoplay muted playsinline></video>
      <img alt="" @click="openPopup" src="@/assets/images/bq.png" class="lang-icon"
        style="width: 24px; height: 24px; border-radius: 100%;">
      <div class="login-container" style="padding-top: 0;">
        <div class="title">
          <!-- <div class="title-box">{{ t('register.a6') }}</div> -->
        </div>
        <!-- <p class="textTitle">{{t('register.a7')}}</p> -->
        <div class="login-ipt">
          <div class="login-type"></div>
          <div class="login-from is-active-1">
            <van-form failed="onFailed" @submit="onSubmit">
              <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
                {{ t('register.a21') }}
              </van-divider>
              <van-field class="form-item" v-model="username" name="username" type="number" :placeholder="t('login.a1')"
                :rules="[{ required: true, message: t('register.a8') }, { pattern: /^\d{5,14}$/, message: t('register.a9') }]">
                <template #label>
                  <div @click="openPopupQh"> +{{ areaCode }} <van-icon name="arrow-down" /></div>
                </template>
              </van-field>
              <van-field class="form-item" v-model="password" name="password"
                :type="isShowPassword ? 'text' : 'password'" :placeholder="t('login.a2')"
                :rules="[{ required: true, message: t('register.a10') }, { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/, message: t('register.a11') }]">
                <template #right-icon>
                  <span class="solts"><van-icon :name="isShowPassword ? 'eye-o' : 'closed-eye'"
                      @click="isShowPassword = !isShowPassword" /></span>
                </template>
              </van-field>
              <van-field class="form-item" v-model="confirmPassword" name="confirmPassword"
                :type="isShowConfirmPassword ? 'text' : 'password'" :placeholder="t('register.a1')"
                :rules="[{ required: true, message: t('register.a12') }, { pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/, message: t('register.a11') }, { validator: validateConfirm, message: t('register.a13') }]">
                <template #right-icon>
                  <span class="solts"><van-icon :name="isShowConfirmPassword ? 'eye-o' : 'closed-eye'"
                      @click="isShowConfirmPassword = !isShowConfirmPassword" /></span>
                </template>
              </van-field>
              <van-field class="form-item" v-model="invite" type="text" name="invite" :placeholder="t('register.a2')"
                :rules="[{ required: true, message: t('register.a14') }]" />
              <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">
                {{ t('register.a22') }}
              </van-divider>
              <van-field class="form-item" v-model="name" name="name" :placeholder="t('register.a23')"
                :rules="[{ required: true, message: t('register.a24') }]">
              </van-field>
              <van-field class="form-item" v-model="fieldValue" name="country" is-link readonly
                :placeholder="t('register.a25')" @click="showPicker = true"
                :rules="[{ required: true, message: t('register.a25') }]" />
              <van-field class="form-item" v-model="card_id" name="card_id" type="number"
                :placeholder="t('register.a15')" :rules="[{ required: true, message: t('register.a15') }]">
              </van-field>
              <van-field name="card_front" class="form-item" :rules="[
                { required: true, message: t('register.a28') }
              ]">
                <!-- Please upload a photo of the front of your ID card. -->
                <template #input>
                  <van-uploader v-model="card_frontYl" :max-count="1" @delete="e => removeImage(e, 'front')"
                    :after-read="(file) => uploadFile(file, 'front')">
                    <div class="card-inner">
                      <div class="lf"><van-icon class="icon" name="photograph" size="30" /></div>
                      <div class="rg">
                        <div class="name-1">{{ t('register.a26') }} </div>
                        <!-- Front side -->
                        <div class="desc">{{ t('register.a27') }}</div>
                        <!-- Choose from your device -->
                      </div>
                    </div>
                  </van-uploader>
                </template>
              </van-field>
              <van-field name="card_back" class="form-item" :rules="[
                { required: true, message: t('register.a29') }
              ]">
                <!-- Please upload a photo of the back of your ID card. -->
                <template #input>
                  <van-uploader v-model="card_backYl" :max-count="1" @delete="e => removeImage(e, 'bront')"
                    :after-read="(file) => uploadFile(file, 'bront')">
                    <div class="card-inner">
                      <div class="lf"><van-icon class="icon" name="photograph" size="30" /></div>
                      <div class="rg">
                        <div class="name-1">{{ t('register.a30') }} </div>
                        <!-- Back side -->
                        <div class="desc">{{ t('register.a27') }}</div>
                      </div>
                    </div>
                  </van-uploader>
                </template>
              </van-field>
              <van-field class="form-item" v-model="email" name="email" type="text" :placeholder="t('register.a31')"
                :rules="[
                  { required: true, message: t('register.a32') },
                  { pattern: emailPattern, message: t('register.a33') }
                ]">
              </van-field>
              <van-field class=" form-item" v-model="address" name="address" type="text"
                :placeholder="t('register.a34')" :rules="[{ required: true, message: t('register.a35') }]">
              </van-field>
              <van-field class="form-item" v-model="income_range" name="income_range" :placeholder="t('register.a36')"
                readonly is-link @click="showIncomePicker = true"
                :rules="[{ required: true, message: t('register.a37') }]" />
              <van-field class="form-item" v-model="net_worth_range" name="net_worth_range"
                :placeholder="t('register.a38')" readonly is-link @click="showRangePicker = true"
                :rules="[{ required: true, message: t('register.a39') }]" />
              <van-field class="form-item" v-model="inv_expTxt" name="inv_exp" :placeholder="t('register.a40')" readonly
                is-link @click="showExpPicker = true" :rules="[{ required: true, message: t('register.a41') }]" />
              <van-field class="form-item" v-model="risk_toleranceTxt" name="risk_tolerance"
                :placeholder="t('register.a42')" readonly is-link @click="showRiskPicker = true"
                :rules="[{ required: true, message: t('register.a43') }]" />

              <van-field name="isAgree" style="padding-left: 0;" :rules="[
                { required: true, validator: validateAgree, message: t('register.a16') }
              ]">
                <template #input>
                  <van-checkbox v-model="isAgree" shape="square" @click="squareFun">
                    <p class="tk">{{ t('register.a17') }}<span>{{ t('register.a18') }}</span></p>
                  </van-checkbox>
                </template>
              </van-field>
              <div class="btn-box">
                <van-button type="default" class="btn" :loading="loading" :loading-text="t('newRouter.a3')"
                  native-type="submit">{{
                    t('register.a5') }} </van-button>
              </div>
              <div class="login-footer"><span>{{ t('register.a3') }}</span><span style="color:#2969FF;"
                  @click="router.push('/')">{{
                    t('register.a4') }}</span></div>
            </van-form>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </div>
  <!-- 注册同意协议弹窗 -->
  <van-popup v-model:show="zyShow" style="background: rgba(0,0,0,0);" closeable close-icon="clear"
    @click-close-icon="closezyShow" @click-overlay="closezyShow">
    <div class="popup-box">
      <div class="content">
        <div class="h1">{{ t('register.a19') }}</div>
        <div class="list-con">
          <div class="title">{{ t('Regulatorynfo.a0') }}</div>
          <p class="p">{{ t('Regulatorynfo.a1') }}</p>
          <p class="p">{{ t('Regulatorynfo.a2') }}</p>
          <div class="title">{{ t('riskDisclosure.a0') }}</div>
          <p class="p">{{ t('riskDisclosure.a1') }}</p>
          <p class="p">{{ t('riskDisclosure.a2') }}</p>
          <p class="p">{{ t('riskDisclosure.a3') }}</p>
          <p class="p">{{ t('riskDisclosure.a4') }}</p>
          <div class="title">{{ t('riskDisclosure.a5') }}</div>
          <p class="p">{{ t('riskDisclosure.a6') }}</p>
          <p class="p">{{ t('riskDisclosure.a7') }}</p>
          <p class="p">{{ t('riskDisclosure.a8') }}</p>
          <p class="p">{{ t('riskDisclosure.a9') }}</p>
          <div class="title">{{ t('riskDisclosure.a10') }}</div>
          <p class="p">{{ t('riskDisclosure.a11') }}</p>
          <p class="p">{{ t('riskDisclosure.a12') }}</p>
          <p class="p">{{ t('riskDisclosure.a13') }}</p>
          <p class="p">{{ t('riskDisclosure.a14') }}</p>
          <div class="title">{{ t('riskDisclosure.a15') }}</div>
          <p class="p">{{ t('riskDisclosure.a16') }}</p>
          <p class="p">{{ t('riskDisclosure.a17') }}</p>
          <p class="p">{{ t('riskDisclosure.a18') }}</p>
          <p class="p">{{ t('riskDisclosure.a19') }}</p>
          <p class="p">{{ t('riskDisclosure.a20') }}</p>
          <div class="title">{{ t('riskDisclosure.a21') }}</div>
          <p class="p">{{ t('riskDisclosure.a22') }}</p>
        </div>
        <van-button type="default" class="btn" :disabled="miao != 0" @click="zyShow = false">
          {{ t('register.a20') }}<span v-if="miao != 0">({{ miao }}s)</span>
        </van-button>
      </div>
    </div>
  </van-popup>
  <!--国籍 -->
  <van-popup v-model:show="showPicker" destroy-on-close round position="bottom">
    <van-picker :model-value="pickerValue" :columns="countryList"
      :columns-field-names="{ text: 'name', value: 'code', children: 'children' }" @cancel="showPicker = false"
      @confirm="onConfirm" />
  </van-popup>
  <!-- 年收入 -->
  <van-popup v-model:show="showIncomePicker" position="bottom">
    <van-picker :columns="incomeOptions" @confirm="onConfirmIncome" @cancel="showIncomePicker = false" />
  </van-popup>
  <!-- 净资产 -->
  <van-popup v-model:show="showRangePicker" position="bottom">
    <van-picker :columns="rangeOptions" @confirm="onConfirmRange" @cancel="showRangePicker = false" />
  </van-popup>
  <!-- 投资经验 -->
  <van-popup v-model:show="showExpPicker" position="bottom">
    <van-picker :columns="expOptions" @confirm="onConfirmExp" @cancel="showExpPicker = false" />
  </van-popup>
  <!-- 风险承受能力 -->
  <van-popup v-model:show="showRiskPicker" position="bottom">
    <van-picker :columns="riskOptions" @confirm="onConfirmRisk" @cancel="showRiskPicker = false" />
  </van-popup>
</template>

<script setup name="registerPage">
import { showSuccessToast, showFailToast, showLoadingToast } from 'vant';
import { register, getNationalityApi, upload } from "@/api"
import { onMounted, ref, onBeforeUnmount } from "vue";
import { eventBus } from '@/utils/eventBus'
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n"
import demoVideo from "@/assets/video/test.mp4"

const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const openPopup = () => { //语言
  eventBus.emit("toggleLangPopup", true)
}
const openPopupQh = () => { //区号
  eventBus.emit("toggleQhPopup", true)
}
eventBus.on("toggleAreaCode", (val) => { //区号切换
  areaCode.value = val
})
// 国籍列表接口
const countryList = ref([])
getNationalityApi().then(res => {
  if (res.code == 200) {
    countryList.value = res.data
  }
})
const fieldValue = ref('');
const showPicker = ref(false);
const pickerValue = ref([]);
const onConfirm = ({ selectedValues, selectedOptions }) => {
  showPicker.value = false;
  pickerValue.value = selectedValues;
  country.value = selectedOptions[0].code;
  fieldValue.value = selectedOptions[0].name;
};
const uploadFile = async (file, type) => {
  if (file.file.size > 5 * 1024 * 1024) {
    showToast(t('register.a44'))
    return
  }
  const formData = new FormData()
  formData.append('file', file.file) // ⚠️ 这里是 file.file

  showLoadingToast({ message: t('register.a45') })
  upload(formData).then(res => {
    if (res.code == 200) {
      if (type === 'front') {
        card_frontYl.value = [{
          url: res.data
        }]
        card_front.value = res.data
      } else {
        card_backYl.value = [{
          url: res.data
        }]
        card_back.value = res.data
      }
      showSuccessToast(res.message)
    }
  }).catch((e) => {
    if (e.code != 200) {
      if (type === 'front') {
        card_frontYl.value = []
        card_front.value = ''
      } else {
        card_backYl.value = []
        card_back.value = ''
      }
    }
  }).finally(() => {
    // closeToast()
  })
}
const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const isShowPassword = ref(false)
const isShowConfirmPassword = ref(false)

const username = ref('')
const areaCode = ref('1')
const password = ref('')
const confirmPassword = ref('')
const invite = ref(route.query.invite || '')
const name = ref('')
const country = ref('') //国籍
const card_id = ref('') //身份证
const card_frontYl = ref([]) //身份证 正面
const card_front = ref('') //身份证 正面
const card_backYl = ref([]) //身份证 反面
const card_back = ref('') //身份证 反面
const email = ref('') //邮箱
const address = ref('') //居住地址
const income_range = ref('') //年收入
const net_worth_range = ref('') //净资产
const inv_exp = ref('') //投资经验
const inv_expTxt = ref('') //投资经验
const risk_tolerance = ref('') //风险承受能力
const risk_toleranceTxt = ref('') //风险承受能力
const isAgree = ref(false)

const validateConfirm = () => {
  return confirmPassword.value === password.value
}

const onFailed = (errorInfo) => {
  console.log('failed', errorInfo);
};
const loading = ref(false)
const onSubmit = (values) => {
  loading.value = true
  register({
    ...values,
    inv_exp: inv_exp.value,
    risk_tolerance: risk_tolerance.value,
    card_back: card_back.value,
    card_front: card_front.value,
    username: areaCode.value + values.username,
    confirmPassword: undefined
  }).then(res => {
    if (res.code == 200) {
      showSuccessToast(res.message)
      router.push('/')
    }
    loading.value = false
  }).catch(() => {
    loading.value = false
  })
};

const showIncomePicker = ref(false)
const incomeOptions = [
  {
    text: t('register.a46'),
    value: t('register.a46'),
  }, {
    text: t('register.a47'),
    value: t('register.a47'),
  }, {
    text: t('register.a48'),
    value: t('register.a48'),
  }, {
    text: t('register.a49'),
    value: t('register.a49'),
  }, {
    text: t('register.a50'),
    value: t('register.a50'),
  }
]
const onConfirmIncome = (value) => {
  income_range.value = value.selectedOptions[0].value
  showIncomePicker.value = false
}

const showRangePicker = ref(false)
const rangeOptions = [
  {
    text: t('register.a46'),
    value: t('register.a46'),
  }, {
    text: t('register.a47'),
    value: t('register.a47'),
  }, {
    text: t('register.a48'),
    value: t('register.a48'),
  }, {
    text: t('register.a49'),
    value: t('register.a49'),
  }, {
    text: t('register.a50'),
    value: t('register.a50'),
  }
]
const onConfirmRange = (value) => {
  net_worth_range.value = value.selectedOptions[0].value
  showRangePicker.value = false
}

const showExpPicker = ref(false)
const expOptions = [
  {
    text: t('register.a51'),
    value: 1
  }, {
    text: t('register.a52'),
    value: 0
  }
]
const onConfirmExp = (value) => {
  inv_exp.value = value.selectedOptions[0].value
  inv_expTxt.value = value.selectedOptions[0].text
  showExpPicker.value = false
}

const showRiskPicker = ref(false)
const riskOptions = [
  {
    text: t('register.a53'),
    value: 1
  }, {
    text:t('register.a54'),
    value: 2
  }
]
const onConfirmRisk = (value) => {
  risk_tolerance.value = value.selectedOptions[0].value
  risk_toleranceTxt.value = value.selectedOptions[0].text
  showRiskPicker.value = false
}

const zyShow = ref(false)
const miao = ref(10)
let timer = null
const validateAgree = () => {
  return isAgree.value === true
}
function squareFun() {
  zyShow.value = true
  miao.value = 10
  if (timer) {
    clearInterval(timer)
  }
  timer = setInterval(() => {
    miao.value--
    if (miao.value == 0) {
      clearInterval(timer)
    }
  }, 1000)
}
function closezyShow() {
  if (timer) {
    clearInterval(timer)
  }
  isAgree.value = false
}
onBeforeUnmount(() => {
  if (timer) {
    clearInterval(timer)
  }
})
</script>
<style scoped lang="scss">
.login {
  min-height: 100vh;
  background: #010413;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;

  video {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .lang-icon {
    position: absolute;
    top: 10px;
    right: 15px;
    width: 24px;
    height: 24px;
    border-radius: 100%;
  }

  .login-container {
    width: 90%;
    margin: 50px auto;
    padding: 30px 0;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    background: rgba(255, 255, 255, 1);
    backdrop-filter: blur(25px);
    position: relative;
    border: none;
    z-index: 2;

    .title {
      font-size: 40px;
      font-family: Roboto;
      font-weight: 900;
      text-transform: uppercase;
      color: #fff;
      margin: auto;
    }

    .textTitle {
      color: #2969FF;
      text-align: center;
      font-family: "Microsoft YaHei UI";
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    .login-ipt {
      flex: 1;
      border-radius: 20px;
      overflow: hidden;

      .login-type {
        display: flex;
        align-items: center;
      }
    }

    .login-from {
      padding: 10px 15px 0;

      .tk {
        color: #333;

        span {
          color: #2969ff;
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }

    .is-active-1 {
      border-top-left-radius: 0;
      border-top-right-radius: 20px;
    }

    .form-item {
      border-radius: 8px;
      opacity: 1;
      background: #f5f8fa;
      box-sizing: border-box;
      color: #2969FF;
      margin-bottom: 15px;

    }

    :deep(.van-cell__title) {
      width: 80px;
      color: #000;
      border-right: 1px solid #a2a7aa;

      i {
        margin-left: 10px;
      }
    }

    :deep(.van-uploader) {
      width: 100%;
    }

    :deep(.van-uploader__wrapper) {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;

      .van-uploader__preview-image {
        // height: 100%;
        max-height: 100px;
        // width: auto;
        // max-width: 100%;
        width: auto;
        height: auto;

        img {
          height: 100%;
          max-height: 100px;
          width: auto;
        }
      }
    }

    :deep(.van-uploader__upload) {
      width: 100%;
      height: auto;
      background: none;
    }

    .card-inner {
      // border: 1px dashed rgba(255, 255, 255, 0.3);
      border-radius: 10px;
      padding: 10px 0 10px;
      text-align: center;
      // background: #1b1b1f;
      color: rgba(51, 51, 51, 0.8);
      display: flex;
      align-items: center;
      gap: 15px;

      .lf {
        background-color: rgba(90, 94, 107, 0.2);
        width: 70px;
        height: 70px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon {
          opacity: 0.4;
        }
      }

      .rg {
        .name-1 {
          font-weight: bold;
          margin-bottom: 10px;

          span {
            color: red;
          }
        }

        .desc {
          font-size: 12px;
          color: #4da3ff;
        }
      }
    }

    .forgot-pwd {
      font-size: 12px;
      color: #2969FF;
      text-align: right;
      margin-top: 10px;
      margin-bottom: 50px;
      display: flex;
      align-content: center;
      justify-content: space-between;
      gap: 10px;

      .online-service {
        text-align: center;
        font-size: 12px;
        color: #2969FF;
      }
    }

    .btn-box {
      border-radius: 8px;
      overflow: hidden;
      margin-top: 30px;

      .btn {
        width: 100%;
        color: white;
        background: #2969FF;
        border-color: #2969FF;
      }
    }

    .login-footer {
      text-align: center;
      font-size: 12px;
      color: #a7afb7;
      margin-top: 15px;
    }
  }
}

// :deep(.van-badge__wrapper) {
//   top: 50px;
//   left: calc(100% - 30px);
// }

.popup-box {
  width: 90vw;
  max-width: 350px;

  .content {
    border-radius: 20px;
    background-color: #FFF;
    position: relative;
    padding-top: 44px;
    padding: 20px 16px 20px 16px;
    background-image: url("@/assets/images/tzbg.png");
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: top;

    .h1 {
      color: #000;
      text-align: center;
      font-family: "Microsoft YaHei UI";
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-bottom: 12px;
    }

    .list-con {
      max-height: 70vh;
      overflow-y: auto;
      color: rgba(0, 0, 0, 0.7);

      .title {
        text-align: center;
        margin-bottom: 10px;
        margin-top: 15px;
        font-weight: bold;
      }

      .p {
        font-size: 14px;
        margin-bottom: 5px;
        text-indent: 2em;
      }
    }

    .btn {
      margin-top: 16px;
      width: 100%;
      border-radius: 10px;
      background: #2969FF;
      border-color: #2969FF;
      color: #FFF;
      text-align: center;
      font-family: "Microsoft YaHei UI";
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }
  }
}
</style>
